export default "__VITE_ASSET__4a92dbe1__"